"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentType = void 0;
exports.DocumentType = {
    Pdf: "PDF",
    Scan: "SCAN",
    Html: "HTML",
    Epub: "EPUB",
    Txt: "TXT",
    SpeechifyBook: "SPEECHIFY_BOOK",
    Unknown: "UNKNOWN",
};
